/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ chars: NonNullable<unknown>, max: NonNullable<unknown> }} Tts_Tool_Chars_LimitInputs */

const en_tts_tool_chars_limit = /** @type {(inputs: Tts_Tool_Chars_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chars}/${i?.max}`)
};

const es_tts_tool_chars_limit = /** @type {(inputs: Tts_Tool_Chars_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chars}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "{chars}/{max}" |
*
* @param {Tts_Tool_Chars_LimitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_chars_limit = /** @type {((inputs: Tts_Tool_Chars_LimitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Chars_LimitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_chars_limit(inputs)
	return en_tts_tool_chars_limit(inputs)
});